var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTileInbox = function SvgIconTileInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#052951",
    d: "M29.143 28.952H2.857V12.713L16 21.178l13.143-8.465z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#052951",
    d: "m2.884 11.45 13.118 8.452 13.168-8.611-12.56-8.164a1.3 1.3 0 0 0-.608-.27 1.3 1.3 0 0 0-.585.265z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B9EA",
    d: "M6.41 13.736V7.05h19.335v6.494l-9.743 6.358z"
  })));
};
export { SvgIconTileInbox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjE0MjkgMjguOTUySDIuODU3MThWMTIuNzEzMUwxNiAyMS4xNzgzTDI5LjE0MjkgMTIuNzEzMVYyOC45NTJaIiBmaWxsPSIjMDUyOTUxIi8+CjxwYXRoIGQ9Ik0yLjg4NDAzIDExLjQ0OTdMMTYuMDAyMyAxOS45MDIzTDI5LjE2OTcgMTEuMjkwOUwxNi42MDkyIDMuMTI3NDZDMTYuNDMzNSAyLjk4NjY3IDE2LjIyNDUgMi44OTM1NyAxNi4wMDIzIDIuODU3MThDMTUuNzg3OSAyLjg5NTA1IDE1LjU4NjUgMi45ODYyMyAxNS40MTY2IDMuMTIyMzJMMi44ODQwMyAxMS40NDk3WiIgZmlsbD0iIzA1Mjk1MSIvPgo8cGF0aCBkPSJNNi40MDk2NyAxMy43MzU1VjcuMDQ5OEgyNS43NDUxVjEzLjU0MzVMMTYuMDAyMiAxOS45MDI0TDYuNDA5NjcgMTMuNzM1NVoiIGZpbGw9IiMwMEI5RUEiLz4KPC9zdmc+Cg==";